import format from 'date-fns/format';

import {
  de,
  enAU,
  enGB,
  enIN,
  enUS,
  es,
  fr,
  it,
  nb,
  pt,
  sv,
  zhCN,
  zhHK,
} from 'date-fns/locale';

export const localeDateMap = {
  swe_sv: { locale: sv, id: 'sv' },
  mex_es: { locale: es, id: 'es' },
  usa_en: { locale: enUS, id: 'enUS' },
  usa_es: { locale: es, id: 'es' },
  esp_es: { locale: es, id: 'es' },
  hkg_zh: { locale: zhHK, id: 'zhHK' },
  bhs_en: { locale: enIN, id: 'enIN' },
  int_en: { locale: enIN, id: 'enIN' },
  lac_es: { locale: es, id: 'es' },
  nor_no: { locale: nb, id: 'no' },
  deu_de: { locale: de, id: 'de' },
  gbr_en: { locale: enGB, id: 'enGB' },
  ita_it: { locale: it, id: 'it' },
  sgp_en: { locale: enIN, id: 'enIN' },
  aus_en: { locale: enAU, id: 'enAU' },
  bra_pt: { locale: pt, id: 'pt' },
  chn_zh: { locale: zhCN, id: 'zhCN' },
  fra_fr: { locale: fr, id: 'fr' },
};

const locales = Object.values(localeDateMap).reduce((formatted, { locale, id }) => {
  formatted[id] = locale;

  return formatted;
}, {});

// https://github.com/date-fns/date-fns/tree/master/src/locale
export default function localizedFormat(date, formatStr = 'PP') {
  const defaultLocale = locales['enUS'];

  const locale = process.browser
    ? locales[window.localeId] || defaultLocale
    : defaultLocale;
  return format(date, formatStr, { locale });
}

export const formatLocale = (date, localeKey, formatStr = 'PP') => {
  const defaultLocale = locales['enUS'];

  const localeId = localeDateMap[localeKey]?.id || 'enUS';

  const locale = locales[localeId] || defaultLocale;
  return format(date, formatStr, { locale });
};

export const customFormat = date => {
  const customDate = new Date(`${date}T00:00:00.000`);
  const dateFormatted = localizedFormat(customDate, 'EEE|LLL|dd|yyyy').replace(
    '.',
    '',
  );
  const [week, month, day, year] = dateFormatted.split('|');

  return {
    week,
    month: month.substring(0, 3),
    day,
    year,
  };
};

